import React, { useEffect, useState } from "react";
import api from "../Axios";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import FirstButton from "../common/button";
import { useNavigate } from "react-router-dom";
import { TextField, Card } from "@mui/material";
import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from "react-share";
import { FacebookIcon, LinkedinIcon, WhatsappIcon } from "react-share";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
const BlogDetails = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  let { id } = useParams();
  const [relatedBlogs, setRelatedBlogs] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
    getBlogDetails();
    getRelatedBlogs();
  }, [id]);
  const getBlogDetails = () => {
    const data = { id: id };
    api
      .post("get-blog", data)
      .then((resp) => {
        setData(resp?.data?.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getRelatedBlogs = () => {
    api
      .get("get-latest-logs", { params: { id } })
      .then((resp) => {
        setRelatedBlogs(resp?.data?.data || []);
      })
      .catch((err) => console.error(err));
  };
  return (
    <div className="search dflex">
      <div
        className="w70 "
        style={{
          borderRight: "1px solid #ddd",
          paddingRight: "20px",
        }}
      >
        {data ? (
          <div className="p-3 bg-white">
            <h1 className="primary_title  about_heading mb-4">{data.title}</h1>
            <img
              src={data.image}
              alt={data.title}
              style={{
                width: "50%",
                height: "auto",
                margin: "auto",
                display: "flex",
              }}
            />
            <div
              className="ql-editor"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </div>
        ) : (
          <p>Loading blog details...</p>
        )}
      </div>

      <div className="w30 p-3 ">
        <h2>Related Blogs</h2>

        {relatedBlogs &&
          relatedBlogs.map((blog) => {
            const shareUrl = `${window.location.origin}/blog-details/${blog._id}`;
            return (
              <Card
                key={blog._id}
                // className="ncs_card"
                style={{ borderRadius: "6px", margin: "20px" }}
                //  onClick={() => navigate(`/blog-details/${blog._id}`)}
              >
                <div className="p-2">
                  <img
                    src={blog.image}
                    className="imgclass"
                    style={{
                      objectFit: "cover",
                      // height: "250px",
                      minHeight: "180px",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                      width: "100%",
                    }}
                  />
                </div>
                <div className="p-2 px-4">
                  <div
                    className="dflex"
                    style={{ justifyContent: "space-between" }}
                  >
                    <div
                      className="dflex align-center vpil"
                      style={{ width: "fit-content", gap: "8px" }}
                    >
                      <CalendarMonthIcon />
                      <p className="ms-2 mb-0 fs-14">
                        {moment(blog.publishedAt).format("MMM Do YY")}
                      </p>
                    </div>
                    <div>
                      {/* WhatsApp Share Button */}
                      <WhatsappShareButton
                        url={shareUrl}
                        title={blog.title}
                        className="mx-3"
                      >
                        <WhatsappIcon size={24} round />
                      </WhatsappShareButton>

                      {/* LinkedIn Share Button */}
                      <LinkedinShareButton url={shareUrl} summary={blog.title}>
                        <LinkedinIcon size={24} round />
                      </LinkedinShareButton>
                    </div>
                  </div>
                  <p
                    className="mt-2 mb-3 fs-20 fw-700"
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {blog.title}
                  </p>
                  <p
                    className="mb-2 fs-14 fw-500 content-preview"
                    dangerouslySetInnerHTML={{ __html: blog.content }}
                  ></p>
                </div>
                <div className="d-flex justify-content-end mb-3 px-4">
                  <FirstButton
                    className="btn-contact"
                    buttonText="Read more"
                    marginTop="2rem"
                    onClick={() => navigate(`/blog-details/${blog._id}`)}
                  />
                </div>
              </Card>
            );
          })}
      </div>
    </div>
  );
};

export default BlogDetails;
